import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';

export type StickyProgressBarCtaVariant =
  | 'main'
  | 'white'
  | 'black'
  | 'success';

@Component({
  selector: 'app-sticky-progress-bar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './sticky-progress-bar.component.html',
  styleUrl: './sticky-progress-bar.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StickyProgressBarComponent {
  currentStep = input.required<number>();
  steps = input<string[]>(['Select your Seats', 'Checkout']);

  ctaLabel = input.required<string>();
  ctaDisabled = input(false);
  ctaVariant = input<StickyProgressBarCtaVariant>('main');
  ctaTooltip = input<string>('');
  ctaDataCy = input<string>('sticky-progress-bar-cta');
  ctaShowLockIcon = input(false);

  ctaClick = output<void>();

  get ctaClasses(): string {
    switch (this.ctaVariant()) {
      case 'white':
        return 'btn-white';
      case 'black':
        return 'btn-black';
      case 'success':
        return this.ctaDisabled() ? 'btn-checkout-gray' : 'btn-success';
      default:
        if (this.ctaDisabled()) {
          return 'btn-cta-disabled';
        }
        return 'btn-main-light';
    }
  }

  onCtaClick(): void {
    if (this.ctaDisabled()) {
      return;
    }
    this.ctaClick.emit();
  }
}
